import level1 from "./levels/1"
import level2 from "./levels/2"
// import level3 from "./levels/3";
import shuffle from "shuffle-array"

// const words = [shuffle(level1), shuffle(level2), shuffle(level3)];
const words = [[], [], shuffle(level1), shuffle(level2)]
export default words
